/**
 * Outlined chip with leading icon by content type — shared with ContentAutocomplete, tag queue, etc.
 * Icon map: {@link getContentTypeIcon} in `gui/utils/content-type-icon`.
 * @module common/ContentTypeChip
 */
import React from 'react'
import { Chip } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'
import { getContentTypeIcon } from 'gui/utils/content-type-icon'

export interface ContentTypeChipProps {
  contentType: string
  label: string
  iconFontSize?: string
  sx?: SxProps<Theme>
}

function ContentTypeChip (props: ContentTypeChipProps) {
  const { contentType, label, iconFontSize = '1rem', sx } = props
  const Icon = getContentTypeIcon(contentType)
  const chipSxParts: SxProps<Theme>[] = []
  if (Icon) {
    chipSxParts.push({ pl: '7px' })
  }
  if (sx) {
    if (Array.isArray(sx)) {
      chipSxParts.push(...sx)
    } else {
      chipSxParts.push(sx)
    }
  }
  const chipSx: SxProps<Theme> | undefined =
    chipSxParts.length > 0 ? (chipSxParts as unknown as SxProps<Theme>) : undefined
  return (
    <Chip
      icon={Icon ? <Icon sx={{ fontSize: iconFontSize }} /> : undefined}
      label={label}
      size="small"
      variant="outlined"
      sx={chipSx}
    />
  )
}

export default ContentTypeChip
